import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import {
  CREATE_ORDEN_INGRESO,
  DELETE_ORDEN_INGRESO,
  GET_ALL_ORDENES_INGRESO,
  GET_ALL_ORDENES_INGRESO_FILES,
  GET_INCOME_ORDERS_BY_DEUDOR_ID,
  GET_ORDEN_INGRESO,
  UPDATE_ORDEN_INGRESO,
} from '../graphql/ordenes-ingreso.queries';
import { OrdenIngreso } from '../models/ordenes-ingreso.models';

@Injectable({
  providedIn: 'root',
})
export class OrdenesIngresoService {
  private readonly graphQL = inject(GraphService);

  /**
   * @description Crea una nueva orden de ingreso
   * @param ordenIngreso - Datos de la orden a crear
   * @returns Observable con el resultado de la creación
   */
  create(ordenIngreso: any): Observable<any> {
    return this.graphQL.mutateGraphQL<any>({
      mutation: CREATE_ORDEN_INGRESO,
      variables: { ordenIngreso },
    });
  }

  /**
   * @description Obtiene una orden de ingreso específica por ID
   * @param id - ID de la orden
   * @returns Observable con la orden de ingreso
   */
  getById(id: string): Observable<any> {
    return this.graphQL.queryGraphQL<any>({
      query: GET_ORDEN_INGRESO,
      variables: { id },
    });
  }

  /**
   * @description Obtiene todas las órdenes de ingreso
   * @returns Observable con la lista de órdenes
   */
  getAll(): Observable<any> {
    return this.graphQL.queryGraphQL<any>({
      query: GET_ALL_ORDENES_INGRESO,
      variables: {},
    });
  }

  /**
   * @description Obtiene las órdenes de ingreso de un cliente específico
   * @param clientId - ID del cliente
   * @returns Observable con la lista filtrada de órdenes
   */
  getIncomeOrdersByDeudorId(
    deudorId: string,
    deudorType?: string,
  ): Observable<any> {
    return this.graphQL.queryGraphQL<any>({
      query: GET_INCOME_ORDERS_BY_DEUDOR_ID,
      variables: { deudorId, deudorType },
    });
  }

  /**
   * @description Obtiene todos los archivos asociados a las órdenes de ingreso
   * @returns Observable con la lista de archivos
   */
  getAllFiles(): Observable<any> {
    return this.graphQL.queryGraphQLSales<any>({
      query: GET_ALL_ORDENES_INGRESO_FILES,
      variables: {},
    });
  }

  /**
   * @description Actualiza una orden de ingreso
   * @param id - ID de la orden a actualizar
   * @param ordenIngreso - Datos a actualizar
   * @returns Observable con el resultado de la actualización
   */
  update(id: string, ordenIngreso: any): Observable<any> {
    return this.graphQL.mutateGraphQL<any>({
      mutation: UPDATE_ORDEN_INGRESO,
      variables: { id, ordenIngreso },
    });
  }

  /**
   * @description Elimina una orden de ingreso
   * @param id - ID de la orden a eliminar
   * @returns Observable con el resultado de la eliminación
   */
  delete(id: string): Observable<any> {
    return this.graphQL.mutateGraphQL<any>({
      mutation: DELETE_ORDEN_INGRESO,
      variables: { id },
    });
  }
}
